import React, { useEffect, useState } from "react";
import { DatePicker, Select } from "antd";
import { get } from "../../../../../services/authService";

const { MonthPicker } = DatePicker;


export const VisitCardFilters = ({onFilterChange}) => {

  const [filters, setFilters] = useState({
    state: "",
    monthYear: null,
  });


  const handleLocation = (state) => {
    setFilters((prevFilters) => ({ ...prevFilters, state }));
    onFilterChange({ ...filters, state });
  };

  const handleMonthYearChange = (date, dateString) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      monthYear: date,
    }));
    onFilterChange({ ...filters, monthYear: date });
  };

  const [allCountries, setAllCountries] = useState([]);

  useEffect(() => {
    const apiCountries = "/api/GeoData/countries";
    get(apiCountries)
      .then((res) => setAllCountries(res.data))
      .catch((error) => console.log(error));
  }, []);

  const { Option } = Select;
  return (
    <div className="filterCards">
      <div className="filterCardInput">
        <label htmlFor="">Location</label>
        <Select
          style={{ width: "200px", marginBottom: "40px" }}
          placeholder="Select Location"
          onChange={handleLocation}
          allowClear
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().startsWith(input.toLowerCase())
          }
        >
          {allCountries.map((country) => (
            <Option key={country.id} value={country.stateName}>
              {country.stateName}
            </Option>
          ))}
        </Select>
      </div>
      <div className="filterCardInput">
        <label htmlFor="date">Date</label>
        <MonthPicker
                id="monthYear"
                placeholder="Select Month and Year"
                onChange={handleMonthYearChange}
                style={{ width: '315px' }}
                format="YYYY-MM"
              />
      </div>
    </div>
  );
};
